<template>
    <div 
        class="px-4 py-3 rounded-md relative my-3"
        :class="{
            'bg-green-100 border-green-100 text-green-800': type === 'success',
            'bg-red-100 border-red-400 text-red-700': type === 'error',
        }"
        role="alert"
    >
        <strong class="font-bold text-sm">
            <slot></slot>
        </strong>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'success',
            },
            loading: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>